/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

interface IProperties {
  className?: string;
}

const ProductIcon = ({ className }: IProperties) => {
  return (
    <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.5008 47.187H4.02866C2.35598 47.187 1 45.8311 1 44.1584V4.02867C1 2.35599 2.35598 1.00001 4.02866 1.00001H36.5867C38.2594 1.00001 39.6154 2.35599 39.6154 4.02867V24.0935"
        stroke="black"
        strokeWidth="1.51433"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="37.7225" cy="36.9653" r="10.2217" stroke="black" strokeWidth="1.51433" fill="none" />
      <mask id="path-3-inside-1_15380_29" fill="white">
        <path d="M48.7014 36.9653C48.7014 39.1367 48.0575 41.2594 46.8511 43.0648C45.6448 44.8703 43.9301 46.2775 41.924 47.1085C39.9178 47.9394 37.7104 48.1569 35.5807 47.7332C33.451 47.3096 31.4947 46.264 29.9593 44.7285C28.4239 43.1931 27.3782 41.2369 26.9546 39.1072C26.531 36.9775 26.7484 34.77 27.5794 32.7639C28.4103 30.7577 29.8175 29.0431 31.623 27.8367C33.4285 26.6303 35.5511 25.9864 37.7225 25.9864V36.9653H48.7014Z" />
      </mask>
      <path
        d="M48.7014 36.9653C48.7014 39.1367 48.0575 41.2594 46.8511 43.0648C45.6448 44.8703 43.9301 46.2775 41.924 47.1085C39.9178 47.9394 37.7104 48.1569 35.5807 47.7332C33.451 47.3096 31.4947 46.264 29.9593 44.7285C28.4239 43.1931 27.3782 41.2369 26.9546 39.1072C26.531 36.9775 26.7484 34.77 27.5794 32.7639C28.4103 30.7577 29.8175 29.0431 31.623 27.8367C33.4285 26.6303 35.5511 25.9864 37.7225 25.9864V36.9653H48.7014Z"
        stroke="black"
        strokeWidth="3.02866"
        mask="url(#path-3-inside-1_15380_29)"
        fill="none"
      />
      <path d="M5.54297 7.05731H22.9578" stroke="black" strokeWidth="1.51433" strokeLinecap="round" />
      <path d="M5.54297 11.6003H20.6863" stroke="black" strokeWidth="1.51433" strokeLinecap="round" />
      <path d="M5.54297 31.2866H24.4721" stroke="black" strokeWidth="1.51433" strokeLinecap="round" />
      <path d="M5.54297 35.8296H24.4721" stroke="black" strokeWidth="1.51433" strokeLinecap="round" />
      <path d="M5.54297 40.3726H24.4721" stroke="black" strokeWidth="1.51433" strokeLinecap="round" />
      <path
        d="M16.4857 21.9713L18.1467 20.8216M30.9857 16.4713L29.2796 20.8216M22.6796 20.3014L26.1148 21.9372"
        stroke="black"
        strokeWidth="1.51433"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14.629" cy="23.7149" r="2.27149" stroke="black" strokeWidth="1.51433" fill="none" />
      <circle cx="20.6863" cy="19.1719" r="2.27149" stroke="black" strokeWidth="1.51433" fill="none" />
      <circle cx="28.2579" cy="22.9578" r="2.27149" stroke="black" strokeWidth="1.51433" fill="none" />
      <circle cx="32.0438" cy="13.8718" r="2.27149" stroke="black" strokeWidth="1.51433" fill="none" />
    </svg>
  );
};

export default ProductIcon;
